<template>
  <div class="base-loading-bar" :class="{ 'is-small': isSmall }">
    <div class="base-loading-bar__base-bar">
      <div class="base-loading-bar__progress"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseLoadingBar',
  props: {
    isSmall: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
};
</script>

<style lang="scss">
@keyframes loader {
  0% {
    left: -50%;
    width: 50%;
  }
  100% {
    left: 100%;
    width: 70%;
  }
}

.base-loading-bar {
  width: 100%;

  &__base-bar {
    height: 3px;
    background-color: $color-neutral-pale;
    border-radius: $border-radius-large;
    position: relative;
    overflow: hidden;
  }

  &__progress {
    animation: loader 1200ms linear infinite;
    background-color: $color-green;
    height: 100%;
    position: absolute;
    left: -50%;
    width: 50%;
  }

  &.is-small {
    .base-loading-bar__base-bar {
      border-radius: 0;
      height: 1px;
    }
  }
}
</style>
